"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DateTimeProvider_1 = require("../Util/DateTimeProvider");
const cache_1 = require("@almservices-cl/cache");
const clock_1 = require("@almservices-cl/clock");
class DateTimeModifierMock extends DateTimeProvider_1.DateTimeModifierImpl {
    constructor(config = new clock_1.DateTimeConfig(new cache_1.InMemoryCache(), {
        dateTime: "YYYY-MM-DD HH:mm:ss",
        date: "YYYY-MM-DD",
        time: "HH:mm:ss",
    })) {
        super(config);
    }
}
exports.default = DateTimeModifierMock;
//# sourceMappingURL=DateTimeModifierMock.js.map